import React from 'react';

const Services = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Our Services</h1>
      <p>Discover the range of services we offer to help your business succeed.</p>
      
      <div style={{ marginTop: '30px' }}>
        <h3>Design and Train</h3>
        <p>Need a custom fine tuned model? Everydream provides end-to-end custom AI models including data collection, model design, and training.</p>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <h3>Deploy</h3>
        <p>Deploy AI to the cloud</p>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <h3>Integrate</h3>
        <p>Integrate with third party services like OpenAI, Anthropic, and Google.</p>
      </div>
    </div>
  );
};

export default Services;
